import messages from '../../locales/messages';
import { ReactElement, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import 'src/common/style/common.scss';
import { ThanksModal, thanksTable } from 'src/common/utils/ThanksModal';
import {
  location,
  pageTitle,
  pageUrl,
  productTitle,
} from '../../constants/spread';

export interface thanksProps {
  m365: number;
  entra: number;
  salesforce: number;
  d365: number;
  gw: number;
  price: string;
  bpName: string;
  advanced: boolean;
  bpConsentMail: boolean;
  storage: boolean;
}

const Thanks = ({
  m365,
  entra,
  salesforce,
  d365,
  gw,
  bpName,
  advanced,
  price,
  bpConsentMail,
  storage,
}: thanksProps): ReactElement => {
  const intl = useIntl();
  const [, setShowThanksModal] = useState(true);
  const titleThanks: thanksTable[] = [
    { group: 'title', value: intl.formatMessage(messages.thank_you) },
    {
      group: 'subTitle',
      value: intl.formatMessage(messages.received_text),
    },
  ];

  const widgetTitleThanks: thanksTable[] = [
    {
      group: 'widgetTitle1',
      value: intl.formatMessage(messages.req_detail),
    },
  ];

  const contentThanks: thanksTable[] = [
    {
      group: String(intl.formatMessage(messages.storageM365)),
      value: String(m365),
    },
  ];

  contentThanks.push({
    group: String(intl.formatMessage(messages.storageEntra)),
    value: String(entra),
  });

  contentThanks.push({
    group: String(intl.formatMessage(messages.storageDynamics)),
    value: String(d365),
  });

  contentThanks.push({
    group: String(intl.formatMessage(messages.storageSalesforce)),
    value: String(salesforce),
  });

  contentThanks.push({
    group: String(intl.formatMessage(messages.storageGW)),
    value: String(gw),
  });

  contentThanks.push({
    group: String(intl.formatMessage(messages.storageGW)),
    value: String(gw),
  });

  contentThanks.push({
    group: String(intl.formatMessage(messages.estimatedMonthy)),
    value: String(price),
  });

  contentThanks.push({
    group: String(
      intl.formatMessage(
        storage
          ? messages.withUnlimitedStorageToggleOn
          : messages.withUnlimitedStorageToggleOff,
      ),
    ),
    value: '',
  });

  bpName &&
    contentThanks.push({
      group: String(intl.formatMessage(messages.bp_title)),
      value: bpName,
    });

  const buttonThanks: thanksTable[] = [
    {
      group: 'button1',
      value: String(intl.formatMessage(messages['returnToEstimator'])),
    },
  ];
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setShowModal(true);
  }, [
    m365,
    entra,
    salesforce,
    gw,
    d365,
    bpName,
    advanced,
    price,
    bpConsentMail,
  ]);
  return (
    <ThanksModal
      showThanksModal={showModal}
      pageTitle={pageTitle}
      object={pageTitle}
      productTitle={productTitle}
      pageUrl={pageUrl}
      location={location}
      titleThanks={titleThanks}
      widgetTitleThanks={widgetTitleThanks}
      contentThanks={contentThanks}
      buttonThanks={buttonThanks}
      setShowThanksModal={setShowThanksModal}
    ></ThanksModal>
  );
};

export default Thanks;
